.chat-container {
  /* display: contents; */
  width: 100%;
  /* display: contents; */
  height: 100cqh;
  /* height: 100%; */
  padding: var(--mantine-spacing-md);
  container-type: size;
  /* display: contents; */
  /* height: 100cqh; */
  /* display: contents; */
  overflow: hidden;
}

.chat {
  position: relative;
  display: grid;
  grid-template: 'content sidebar' 1fr / 1fr min-content;
  /* overflow: auto; */
}

.thread-list {
  grid-area: sidebar;
  overflow: hidden;
  border-left: 1px solid var(--mantine-color-dark-4);
}

.thread-list-toggle {
  position: absolute;
  position-anchor: --viewport-footer;
  right: anchor(right);
  bottom: anchor(top);
  margin: var(--mantine-spacing-md);
  z-index: 10;
  /* translate: calc(-100% - var(--mantine-spacing-xs)) var(--mantine-spacing-xs); */
}

.thread {
  anchor-name: --thread;
  grid-area: content;
  height: 100cqh;
  overflow: auto;
}
